// Achats à l'unité (PRD lot 3) : le paiement se fait sur la plateforme principale, qui vérifie
// l'article et la cible et lit le prix dans le catalogue ; retour ici après le paiement.
const PLATEFORME = 'https://app.innovactive360.cloud';

export const lienAchat = (article, cible) => {
  const p = new URLSearchParams({ article, retour: 'bourse' });
  if (cible) p.set('cible', cible);
  return `${PLATEFORME}/achats/nouveau?${p.toString()}`;
};

export const dateCourte = (iso) => (iso ? new Date(iso).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' }) : '');
